export const BASE_URL = 'https://paw-hut.b.goit.study/api/';

export const ENDPOINTS = {
  categories: 'categories',
  animals: 'animals',
  feedbacks: 'feedbacks',
  orders: 'orders',
};
